"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var MappingProperties_1 = require("./MappingProperties");
var Field_1 = require("../../constants/Field");
var Objects_1 = require("../../api/Objects");
var Types_1 = require("../../api/Types");
var ModelConstants_1 = require("../../constants/ModelConstants");
var DataItem_1 = require("../common/base/DataItem");
var ModelBase_1 = require("../ModelBase");
var DataType_1 = require("../common/base/DataType");
var uuid_1 = require("uuid");
var lodash_1 = require("lodash");
var MappingModel = /** @class */ (function () {
    function MappingModel() {
    }
    MappingModel.fromJson = function (json) {
        var mappingModel = new MappingModel();
        mappingModel.model = json[Field_1.FIELD.MODEL];
        mappingModel.type = json[Field_1.FIELD.TYPE];
        mappingModel.objectId = json[Field_1.FIELD.OBJECTID];
        mappingModel.version = json[Field_1.FIELD.VERSION];
        mappingModel.properties = MappingProperties_1.MappingProperties.fromJson(json[Field_1.FIELD.PROPERTIES]);
        return mappingModel;
    };
    MappingModel.createNewMappingModel = function (associatedObjectTypeId, associatedObjectTypeVersion, deviceTypeModel, deviceTypeVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mappingModel, _a, type, typeDataItem, deviceType, mappingProperties;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        mappingModel = new MappingModel();
                        mappingModel.model = ModelConstants_1.ModelConstants.MappingModel;
                        _a = mappingModel;
                        return [4 /*yield*/, MappingModel.getLatestMappingsType()];
                    case 1:
                        _a.type = _b.sent();
                        type = associatedObjectTypeId + '@' + associatedObjectTypeVersion.split('.')[0];
                        typeDataItem = new DataItem_1.DataItem(Field_1.FIELD.TYPEID, DataType_1.DataType.string);
                        typeDataItem.dataType = undefined;
                        typeDataItem.value = type;
                        deviceTypeModel.dataType = undefined;
                        deviceTypeVersion.dataType = undefined;
                        deviceType = new ModelBase_1.ModelBase(deviceTypeModel, typeDataItem, deviceTypeVersion);
                        mappingProperties = new MappingProperties_1.MappingProperties(deviceType, []);
                        mappingModel.properties = mappingProperties;
                        return [2 /*return*/, mappingModel];
                }
            });
        });
    };
    MappingModel.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.MODEL] = this.model;
        json[Field_1.FIELD.TYPE] = this.type;
        if (this.objectId) {
            json[Field_1.FIELD.OBJECTID] = this.objectId;
        }
        else {
            json[Field_1.FIELD.OBJECTID] = uuid_1.v4();
        }
        if (this.version) {
            json[Field_1.FIELD.VERSION] = this.version;
        }
        json[Field_1.FIELD.PROPERTIES] = this.properties.toJson();
        return json;
    };
    MappingModel.prototype.saveMappings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json, objects, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        json = this.toJson();
                        delete json[Field_1.FIELD.VERSION];
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.saveObject(JSON.stringify(json))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    MappingModel.prototype.updateMappings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json, objects, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        json = this.toJson();
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.updateObject(this.objectId, this.model, JSON.stringify(json))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    MappingModel.prototype.deleteMappings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objects;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.deleteObject(this.objectId, this.model)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MappingModel.prototype.deleteAllModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objects, promises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objects = new Objects_1.Objects();
                        promises = lodash_1.map(this.properties.sceEngModels, function (sceEnggModel) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, objects.deleteObject(sceEnggModel.id, ModelConstants_1.ModelConstants.SceModel)];
                                    case 1:
                                        _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MappingModel.getLatestMappingsType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, mappingModelVersions, versions, mappingType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeVersions(ModelConstants_1.ModelConstants.MappingModel, ModelConstants_1.ModelConstants.MappingModel)];
                    case 1:
                        mappingModelVersions = _a.sent();
                        versions = mappingModelVersions.data.versions;
                        mappingType = ModelConstants_1.ModelConstants.MappingModel + "@" + versions[versions.length - 1].split('.')[0];
                        return [2 /*return*/, mappingType];
                }
            });
        });
    };
    return MappingModel;
}());
exports.MappingModel = MappingModel;
//# sourceMappingURL=MappingModel.js.map